import { Badge, Icon } from '@/components/ui';

import { blockedActionReason, restrictionLabel } from './accountStanding';

/** "Account suspended" (banned, deactivated) beside the status badge; nothing otherwise. */
export function CandidateRestrictionBadge({ row }) {
  const label = restrictionLabel(row);
  if (!label) return null;
  return (
    <Badge tone="danger" title={blockedActionReason(row)}>
      <Icon name="suspended" size={11} className="shrink-0" />
      {label}
    </Badge>
  );
}

/**
 * Wraps a disabled control so its reason still shows on hover: a disabled
 * button receives no pointer events, so neither the browser's `title` nor
 * our hover label would appear on it. Renders the child alone when there is
 * no reason.
 */
export function BlockedAction({ reason, children, className }) {
  if (!reason) return children;
  return (
    <span title={reason} className={className ?? 'inline-flex cursor-not-allowed'}>
      {children}
    </span>
  );
}
